const LABEL_HEIGHT = 22;
const LABEL_GAP = 8;
const LANE_STEP = 30;

function nodeCenter(node) {
    const width = Number(node?.measured?.width ?? node?.width ?? 230);
    const height = Number(node?.measured?.height ?? node?.height ?? 120);

    return {
        x: Number(node?.position?.x ?? 0) + width / 2,
        y: Number(node?.position?.y ?? 0) + height / 2,
    };
}

function estimateLabelWidth(label) {
    return Math.max(42, String(label ?? '').length * 6.6 + 18);
}

export function edgeLabelRect(edge, nodesById) {
    const source = nodeCenter(nodesById.get(edge.source));
    const target = nodeCenter(nodesById.get(edge.target));
    const width = estimateLabelWidth(edge.label);
    const x = (source.x + target.x) / 2 + Number(edge.data?.labelOffsetX ?? 0);
    const y = (source.y + target.y) / 2 + Number(edge.data?.labelOffsetY ?? 0);

    return {
        left: x - width / 2,
        right: x + width / 2,
        top: y - LABEL_HEIGHT / 2,
        bottom: y + LABEL_HEIGHT / 2,
    };
}

export function labelRectsOverlap(left, right) {
    return left.left < right.right + LABEL_GAP
        && left.right + LABEL_GAP > right.left
        && left.top < right.bottom + LABEL_GAP
        && left.bottom + LABEL_GAP > right.top;
}

function lanes(limit) {
    const values = [0];
    for (let lane = 1; lane <= limit; lane++) values.push(lane, -lane);

    return values;
}

export function separateEdgeLabels(nodes, edges, direction = 'TB') {
    const nodesById = new Map((nodes ?? []).map((node) => [node.id, node]));
    const placed = [];
    const horizontal = direction === 'LR' || direction === 'RL';
    const visibleLabels = (edges ?? []).filter((edge) => !edge.hidden && edge.label
        && nodesById.has(edge.source) && nodesById.has(edge.target));
    const orderedIds = new Set(visibleLabels
        .sort((left, right) => String(left.id).localeCompare(String(right.id)))
        .map((edge) => edge.id));

    return (edges ?? []).map((edge) => {
        if (!orderedIds.has(edge.id)) return edge;

        for (const lane of lanes((placed.length + 1) * 4)) {
            const data = {
                ...edge.data,
                labelOffsetX: horizontal ? 0 : lane * LANE_STEP,
                labelOffsetY: horizontal ? lane * LANE_STEP : 0,
            };
            const candidate = { ...edge, data };
            const rect = edgeLabelRect(candidate, nodesById);
            if (placed.every((other) => !labelRectsOverlap(rect, other))) {
                placed.push(rect);

                return candidate;
            }
        }

        return edge;
    });
}
